
import { debugMode, SEARCH_LIMIT, RESULT_LIMIT_FOR_PAUSE } from './filter-logic-config.js';

/**
 * Execute search via window.myEach, then apply empty-query shuffle and SEARCH_LIMIT slicing.
 * Manages searchStateManager._paused for LazyLoad continuation.
 * @returns {Array} Final matches array (post-shuffle, post-slice)
 */
export function runSearch({ inputList, conditions, query, queryOriginal, queryChanged, filesBeforeSearch }) {
    if (debugMode === '1') {
        console.log('[SEARCH] Files before search:', filesBeforeSearch, '(after category filters)');
    }

    let matches = invokeMyEach(inputList, conditions, queryOriginal, queryChanged, filesBeforeSearch);

    if (debugMode === '1' && queryOriginal && queryChanged) {
        const state = window.searchStateManager;
        if (state && state.highPriorityResults && state.lowPriorityResults) {
            console.log('[SEARCH] Final:', matches.length, 'results (HIGH:', state.highPriorityResults.length, 'LOW:', state.lowPriorityResults.length, 'skipped:', state.highPriorityFoundKeys?.size || 0, ')');
        } else {
            console.log('[SEARCH] Matching:', filesBeforeSearch, 'files ->', matches.length, 'matches');
        }
    }

    matches = applyEmptyQueryShuffle(matches, query);

    if (Array.isArray(matches) && matches.length > SEARCH_LIMIT) {
        matches = matches.slice(0, SEARCH_LIMIT);
    }
    return matches;
}

function invokeMyEach(inputList, conditions, queryOriginal, queryChanged, filesBeforeSearch) {
    if (typeof window.myEach !== 'function') return [];

    const isResuming = window.searchStateManager && window.searchStateManager._paused === true;

    if (debugMode === '1' && queryOriginal && queryChanged) {
        console.log('[SEARCH] Starting:', queryOriginal, '|', filesBeforeSearch, 'files', isResuming ? '(resuming)' : '');
    }

    const searchResult = window.myEach(inputList, conditions, true, false, false, RESULT_LIMIT_FOR_PAUSE, isResuming);

    // Backward compatibility: array return = legacy, object return = pause/resume protocol
    if (Array.isArray(searchResult)) {
        return searchResult;
    }
    if (searchResult && typeof searchResult === 'object') {
        const matches = searchResult.results || [];
        updatePauseState(searchResult, matches);
        return matches;
    }
    return [];
}

function updatePauseState(searchResult, matches) {
    if (!searchResult.isComplete && searchResult.canContinue) {
        if (window.searchStateManager) {
            window.searchStateManager._paused = true;
        }
        if (debugMode === '1') {
            const state = window.searchStateManager;
            console.log('[SEARCH] Paused:', matches.length, 'results (HIGH:', state?.highPriorityResults?.length || 0, 'LOW:', state?.lowPriorityResults?.length || 0, ')');
        }
    } else if (window.searchStateManager) {
        window.searchStateManager._paused = false;
    }
}

function applyEmptyQueryShuffle(matches, query) {
    const isEmpty = !query || (typeof query === 'string' && !query.trim());
    if (!isEmpty) return matches;
    if (!window.searchEngine || typeof window.searchEngine.getSeedForEmptyQuery !== 'function') return matches;

    const seed = window.searchEngine.getSeedForEmptyQuery(false);
    return window.searchEngine.selectRandomFiles(matches, seed);
}
